<svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
  {...$$props}
>
  <path
    d="M7.29289 4.70711C7.68342 4.31658 8.31658 4.31658 8.70711 4.70711L11.2929 7.29289C11.6834 7.68342 11.6834 8.31658 11.2929 8.70711L8.70711 11.2929C8.31658 11.6834 7.68342 11.6834 7.29289 11.2929L4.70711 8.70711C4.31658 8.31658 4.31658 7.68342 4.70711 7.29289L7.29289 4.70711Z"
    fill="currentColor"
  />
  <path
    d="M6.93934 2.76777C7.52513 2.18198 8.47487 2.18198 9.06066 2.76777L13.2322 6.93934C13.818 7.52513 13.818 8.47487 13.2322 9.06066L9.06066 13.2322C8.47487 13.818 7.52513 13.818 6.93934 13.2322L2.76777 9.06066C2.18198 8.47487 2.18198 7.52513 2.76777 6.93934L6.93934 2.76777Z"
    stroke="currentColor"
  />
</svg>
